"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const functions_1 = require("@/common/functions");
const _1 = require(".");
function default_1({ isSecondPayment, paymentDetail, setPaymentDetail, setPaymentMethodDialog, invalidateUserInfo, confirm, disablePending, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { id: order_id, room_fee_free, second_payment_request, room_fond_id } = paymentDetail;
        const validateData = { order_id, payment_type: isSecondPayment ? 'second_pay' : 'after_pay' };
        isSecondPayment &&
            Object.assign(validateData, { second_payment_request_id: second_payment_request === null || second_payment_request === void 0 ? void 0 : second_payment_request.id });
        const isFeeFreeFirstPay = room_fee_free && !isSecondPayment;
        const isUsedCategory = 1018 <= room_fond_id && room_fond_id <= 1021;
        yield (0, api_1.postData)('/api/v1/credit/validate-credit-pay', validateData)
            .then((res) => __awaiter(this, void 0, void 0, function* () {
            if (res.status === 202) {
                // ? 크레딧 부족 -> 결제수단 Dialog
                setPaymentMethodDialog(() => ({
                    showDialog: true,
                    showPaypalDialog: false,
                    isSecondPayment,
                    payMethod: isFeeFreeFirstPay ? 'vbank' : isUsedCategory ? 'trans' : 'card',
                    payInfo: res.data.result,
                }));
            }
            else {
                yield (0, _1.refetchPaymentDetail)({ setPaymentDetail });
                invalidateUserInfo();
                (0, functions_1.showToastMessage)({ message: `${i18next_1.default.t('지갑 잔액으로 결제완료')}🧡` });
            }
        }))
            .catch((err) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
            if (errorStatus === 404)
                (0, errors_1.notFoundConfirm)({ confirm, isForm: true });
            else if (errorStatus === 403)
                (0, errors_1.handle403Error)(err);
            else if (errorStatus === 400) {
                const errorResult = err.response.data.result;
                (0, _1.handlePurchasePayment400Error)({
                    errorResult,
                    setPaymentDetail,
                    confirm,
                });
            }
            else {
                (0, functions_1.showToastMessage)({ message: i18next_1.default.t('새로고침 후 다시 시도해주세요') });
            }
        }))
            .finally(disablePending);
    });
}
exports.default = default_1;
